import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconMappedPromoGames: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.40453 2.49486L9.14014 4.23047L7.40453 2.49486Z" fill="currentColor" />
    <path
      d="M7.40453 2.49486L9.14014 4.23047M11.4543 0.817383V3.27193M15.5041 2.49486L13.7685 4.23047M17.1816 6.54466H14.7271M15.5041 10.5945L13.7685 8.85884M11.4543 12.2719V9.81738M7.40453 10.5945L9.14014 8.85884M5.72705 6.54466H8.1816"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.2854 6.71484L1.4502 16.55"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
